import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Delete from "./Delete.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Rubros extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "pk",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Cant. Empresas",
                    id: "empresas__count",
                    accessor: "empresas__count",
                    filterable: false,
                    width: 100,
                    className: "text-right",
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'rubros_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'rubros_detail',
                        component: Detail,
                    },
                    {                        
                        edit:true,
                        permission: 'rubros_edit',
                        component: Edit,
                    },
                    {
                        edit:true,
                        permission: 'rubros_delete',
                        component: Delete,
                    }
                ]}
                apiUrl={api.clientes.rubros.list}
                columns={this.state.columns}
                exportUrl={api.clientes.rubros.export}
                title={"Rubros"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Rubros;



// WEBPACK FOOTER //
// ./src/views/clientes/Rubros/Rubros.js